import moment from "moment";
import { ModalTopSection } from "../../../components/DetailsModal/ModalTopSection";
import {
  DataLoadingView,
  ErrorOccuredView,
  ModalContainer,
  SectionSubheader,
} from "../../../components";
import { ModalSectionTitle } from "../../../components";
import { LeftRightFlexedContainer } from "../../../components";
import { IBeneficiaryDetailsModalViewProps } from "./GatewayBeneficiaryDetailsModal";
import { appConfig } from "../../../configs";
import { countries, currencies } from "../../../constants";
import { SingleTransferNoBatchList } from "../../Transfers";
import { beneficiaryTypes } from "../../../enums";

export const View = (props: IBeneficiaryDetailsModalViewProps) => {
  const beneficiaryCountry = countries
    .find(
      (grp) =>
        grp.options.find((ctry) => ctry.value === props.modalData?.country) !==
        undefined
    )
    ?.options.find((ctry) => ctry.value === props.modalData?.country);

  // TODO: add a global context with supported countries and currencies
  // const currency = swAppSupportedCurrencies.find((cur) => cur.value === item.currency);
  const beneficiaryCurrency = currencies.find(
    (cur) => cur.value === props.modalData?.currency
  );

  return (
    <div className="beneficiary-details--container">
      <ModalContainer
        isModalOpen={props.isModalOpen}
        closeModal={props.closeModal}
        className="payment-modal-container"
        modalHeader={
          !props.modalData ? (
            <SectionSubheader title="BENEFICIARY DETAILS" />
          ) : (
            <ModalTopSection
              header="BENEFICIARY DETAILS"
              subHeader={
                <div className="name-sub-header flex-container align-items--end justify-content--start">
                  {props.modalData.email}
                </div>
              }
              copyText="Beneficiary ID"
              copyContent={props.modalData.id}
              closeModal={props.closeModal}
            />
          )
        }
      >
        {!props.modalData ? (
          <>
            {props.isLoadingModalData ? (
              <DataLoadingView message={"Loading beneficiary details"} />
            ) : (
              <ErrorOccuredView
                message={
                  "An error occured while loading the beneficiary details. Please retry..."
                }
              />
            )}
          </>
        ) : (
          <>
            <>
              <LeftRightFlexedContainer
                key_id="Alias/Nickname"
                value={props.modalData.full_name || "..."}
              />
              <LeftRightFlexedContainer
                key_id="Email"
                value={props.modalData.email}
              />
              {!props.modalData.phone_number ? null : (
                <LeftRightFlexedContainer
                  key_id="Phone Number"
                  value={props.modalData.phone_number}
                />
              )}
              <LeftRightFlexedContainer
                key_id="Date Added"
                value={moment(props.modalData.created_at).format(
                  appConfig.dateTimeFormat
                )}
              />

              {
                <LeftRightFlexedContainer
                  key_id="Country"
                  value={beneficiaryCountry?.text ?? props.modalData.country}
                />
              }
              {
                <LeftRightFlexedContainer
                  key_id="Currency"
                  value={beneficiaryCurrency?.text ?? props.modalData.currency}
                />
              }
              {
                <LeftRightFlexedContainer
                  key_id="Bank Name"
                  value={props.modalData.gateway_name}
                />
              }
              {
                <LeftRightFlexedContainer
                  key_id="Account Name"
                  value={props.modalData.merchant_name}
                />
              }
              {
                <LeftRightFlexedContainer
                  key_id="Account Number"
                  value={props.modalData.merchant_id_or_code}
                />
              }
              {
                <LeftRightFlexedContainer
                  key_id="Description"
                  value={props.modalData.description || "..."}
                />
              }
              {
                <LeftRightFlexedContainer
                  key_id="Beneficiary Type"
                  value={"GATEWAY BENEFICIARY"}
                />
              }
            </>

            <>
              <ModalSectionTitle key_id="Transfers History" value="" />
              <SingleTransferNoBatchList
                queryFilters={{
                  country: props.modalData.country,
                  currency: props.modalData.currency,
                  gatewayTransferFilter:
                    props.modalData.beneficiary_type ===
                    beneficiaryTypes.gateway
                      ? {
                          merchant_id_or_code:
                            props.modalData.merchant_id_or_code,
                          recipient_gateway_code:
                            props.modalData.recipient_gateway_code,
                          // merchant_name: props.modalData.merchant_name,
                          // gateway_name: props.modalData.gateway_name,
                        }
                      : {},
                }}
              />
            </>
          </>
        )}
      </ModalContainer>
    </div>
  );
};
